const calendarActivityTypes = {
  TASK: 'TASK',
  MEETING: 'MEETING'
};

export default calendarActivityTypes;